import React, { useState } from "react";
import { NavLink, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { useValidateUserAndGetDetailsQuery } from "../store/api/orderApi";
import moment from 'moment';



const Ordergrocerymenubar = ({ filterMenu, catItems }) => {
    const [selectedItem, setSelectedItem] = useState(catItems[0]);
    const userInfo = useSelector((state) => state.authentication.userInfo);
    const { data: userData } = useValidateUserAndGetDetailsQuery(userInfo.emailId);

    let userEventDate = "";

    if (userData?.listChurchNewEvents.length) {
        let date = new Date(userData.listChurchNewEvents[0].eventFromDate);
        userEventDate = moment(date).format("MMM Do, YYYY");
    }


    return (
            <div className="menubar scrollbar fixed-top">
                <div className="disclaimer">
                    <span>Order date:</span>
                    {!userData?.listChurchNewEvents?.length ?
                        <span className="date">Not scheduled</span>
                        :
                        <span className="date">{userEventDate}</span>
                    }
                </div>
                <div className="menubarItems">
                    {
                        catItems.map((curElem, index) => {
                            return <>
                                <NavLink className="" key={index.id} to={index} activeClassName="is-active" onClick={() => { filterMenu(curElem); setSelectedItem(curElem) }} >
                                    <button className={`btn menubutton ${(selectedItem && selectedItem === curElem) && "selectedItem"}`}>{curElem}</button>
                                </NavLink>
                                 </>
                        })
                    }
                </div>


            </div>
    )
}

export default Ordergrocerymenubar;